import { Api } from "../axios-config";

export type BannerDashboardPreference = {
	showBanners: boolean;
};

// Contrato consumido pelo front:
// GET  /banners/dashboard-visibility  -> { showBanners: boolean }
// PUT  /banners/dashboard-visibility  -> { showBanners: boolean }
// Observação: esta preferência é tratada como configuração GLOBAL (sistema inteiro).
const ENDPOINT = "/banners/dashboard-visibility";

const getDashboardVisibility = async (): Promise<BannerDashboardPreference | Error> => {
	try {
		const { data } = await Api().get(ENDPOINT);
		if (data && typeof data.showBanners === "boolean") {
			return { showBanners: data.showBanners };
		}
		return new Error("Resposta inválida ao buscar preferência de banners.");
	} catch (error) {
		return new Error("Não foi possível buscar a preferência de banners.");
	}
};

const setDashboardVisibility = async (showBanners: boolean): Promise<BannerDashboardPreference | Error> => {
	try {
		const { data } = await Api().put(ENDPOINT, { showBanners });
		if (data && typeof data.showBanners === "boolean") {
			return { showBanners: data.showBanners };
		}

		// Se o backend não retornar payload, consideramos sucesso (idempotente)
		return { showBanners };
	} catch (error) {
		return new Error("Não foi possível salvar a preferência de banners.");
	}
};

export const BannerPreferencesService = {
	getDashboardVisibility,
	setDashboardVisibility,
};
